<script setup lang="ts">
defineOptions({ name: 'ThemeButton' })

withDefaults(
  defineProps<{
    variant?: 'primary' | 'secondary'
    block?: boolean
    disabled?: boolean
  }>(),
  { variant: 'primary', block: false, disabled: false },
)
</script>

<template>
  <button
    :disabled="disabled"
    :class="[
      'h-12 rounded-[14px] text-base font-medium transition-opacity',
      variant === 'primary' ? 'bg-brand text-white' : 'bg-surface/50 text-ink/50',
      block ? 'w-full' : '',
      disabled ? 'opacity-50' : '',
    ]"
  >
    <slot />
  </button>
</template>
